export type DashboardRange = '30d' | '60d' | '90d' | '120d' | '150d' | '180d';

export type DashboardWorkflowStatus =
  | 'success'
  | 'error'
  | 'skipped'
  | 'processing'
  | 'ok'
  | 'omitted'
  | 'redirected';

export interface DashboardSummaryMetrics {
  total_transactions: number;
  success: number;
  error: number;
  skipped: number;
  processing: number;
  redirected: number;
  success_rate: number;
  error_rate: number;
  workflows_with_incidents: number;
  workflows_with_error: number;
  workflows_with_skipped: number;
}

export interface DashboardDistributionItem {
  status: DashboardWorkflowStatus | string;
  count: number;
  percentage: number;
}

export interface DashboardDistribution {
  total: number;
  distribution: DashboardDistributionItem[];
}

export interface DashboardVolumeItem {
  hour: number;
  label: string;
  total: number;
  success: number;
  failed: number;
  skipped: number;
  processing: number;
  redirected: number;
}

export interface DashboardIntegrationItem {
  workflow_id: number;
  workflow_name: string;
  workflow_description: string;
  current_status: DashboardWorkflowStatus | string;
  total_transactions: number;
  success_count: number;
  error_count: number;
  skipped_count: number;
  processing_count: number;
  redirected_count: number;
  last_execution: string;
  tendency_pct: number | null;
  tendency_label: string | null;
}

export interface DashboardSummaryResponse {
  summary: DashboardSummaryMetrics;
  distribution: DashboardDistribution;
  volume: DashboardVolumeItem[];
  integrations: DashboardIntegrationItem[];
}

export interface DashboardSummaryQueryParams {
  range?: DashboardRange | string;
  workflow_id?: number;
  status?: DashboardWorkflowStatus | string;
}

export interface WorkflowOption {
  id: number;
  name: string;
}

export interface WorkflowListResponse {
  data: WorkflowOption[];
  total: number;
  limit: number;
  page: number;
}

export const EMPTY_DASHBOARD_SUMMARY: DashboardSummaryResponse = {
  summary: {
    total_transactions: 0,
    success: 0,
    error: 0,
    skipped: 0,
    processing: 0,
    redirected: 0,
    success_rate: 0,
    error_rate: 0,
    workflows_with_incidents: 0,
    workflows_with_error: 0,
    workflows_with_skipped: 0,
  },
  distribution: {
    total: 0,
    distribution: [],
  },
  volume: [],
  integrations: [],
};
